import { render, staticRenderFns } from "./MatchEdit.vue?vue&type=template&id=4ed6c735&scoped=true&"
import script from "./MatchEdit.vue?vue&type=script&lang=js&"
export * from "./MatchEdit.vue?vue&type=script&lang=js&"
import style0 from "./MatchEdit.vue?vue&type=style&index=0&id=4ed6c735&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed6c735",
  null
  
)

export default component.exports